// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3oq-6","label":"Labeled_label__1hfzs","divider":"Labeled_divider__37Sy4"};